import Script from 'next/script';

interface NewrelicProps {
  browserTimingHeader: string;
}

/**
 * Component for rendering newrelic browser timing header
 **/
function Newrelic({ browserTimingHeader }: NewrelicProps) {
  return browserTimingHeader ? (
    <Script dangerouslySetInnerHTML={{ __html: browserTimingHeader }} id="browser-timing-header" />
  ) : null;
}

export default Newrelic;
